import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircleIcon } from '@heroicons/react/24/outline';
import { Card, CardContent } from '../components/common/Card';
import { Button } from '../components/common/Button';
import { useTranslation } from 'react-i18next';

export const PasswordResetSuccess = () => {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
            <CheckCircleIcon className="h-6 w-6 text-green-600" />
          </div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            {t('auth.resetSuccess.title')}
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            {t('auth.resetSuccess.description')}
          </p>
        </div>

        <Card>
          <CardContent className="p-6">
            <Link to="/login">
              <Button className="w-full">
                {t('auth.resetSuccess.signIn')}
              </Button>
            </Link>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};